export default __webpack_public_path__ + "static/media/menuLogo.43bb0bb7.png";